module.exports = __webpack_public_path__ + "media/ca_slide27_programa2.5819272f.mp4";